import config from "src/config";

import { ResponseDto } from "src/dtos/common/responseDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/Equipment`;



export const getEquipmentPopupList = async (searchText: string) => {
	return await getData<ResponseDto<EquipmentDto[]>>(`${baseUrl}/modal`, {
		params: { searchText }
	});
};



